import { RegionType, RetailList, regionTypeOptions } from "@api/throughShipment/throughShipmentApi";
import sortRetailByPinned from "@utils/retailerUtils";

export type AllocationChannelType = "warehouse" | "retailer";

export type AllocationDestinationType = typeof TRYALL_STOCK_CHANNEL_ID | RegionType;

export type AllocationChannelOption =
  | { label: string; channelId: typeof TRYALL_STOCK_CHANNEL_ID; kind: "warehouse" }
  | { label: string; channelId: RegionType; kind: "retailer" };

interface AllocationTargetRestrictedRetailer {
  name: string;
  regionType: RegionType;
}

export const TRYALL_STOCK_CHANNEL_ID = 0 as const;

export const TRYALL_STOCK_CHANNEL_OPTION = { label: "總倉", value: TRYALL_STOCK_CHANNEL_ID } as const;

// 暫時限制：目前僅開放以下零售商可作為配貨位置，清單為空時代表不限制，之後將恢復開放所有通路
export const ALLOCATION_TARGET_RESTRICTED_RETAILERS: AllocationTargetRestrictedRetailer[] = [
  { name: "B2C-UrMart", regionType: RegionType.DOMESTIC_ONLINE },
  { name: "B2C-蝦皮轉單", regionType: RegionType.DOMESTIC_ONLINE },
];

export const allocationChannelOptions: AllocationChannelOption[] = [
  { label: "總倉", channelId: TRYALL_STOCK_CHANNEL_ID, kind: "warehouse" },
  ...regionTypeOptions.map((o): AllocationChannelOption => ({ label: o.label, channelId: o.value, kind: "retailer" })),
];

/**
 * 組裝「配貨位置」下拉選單的通路類型選項，依白名單過濾 regionType，來源為零售商時加上總倉選項
 * @param kind - 配貨來源的種類（總倉或零售商）
 * @returns 通路類型選項清單
 */
export const buildAllocationChannelOptions = (
  kind: AllocationChannelType,
): { label: string; value: AllocationDestinationType }[] => {
  const allowedRegionTypes = new Set(ALLOCATION_TARGET_RESTRICTED_RETAILERS.map((r) => r.regionType));
  const availableRegionTypeOptions =
    allowedRegionTypes.size > 0 ? regionTypeOptions.filter((o) => allowedRegionTypes.has(o.value)) : regionTypeOptions;
  const retailerOpts = availableRegionTypeOptions.map((o) => ({ label: o.label, value: o.value }));
  if (kind === "retailer") {
    return [TRYALL_STOCK_CHANNEL_OPTION, ...retailerOpts];
  }
  return retailerOpts;
};

/**
 * 依白名單過濾零售商清單，並將指定名單置頂排序
 * @param list - 原始零售商清單
 * @returns 過濾並排序後的下拉選單選項
 */
export const buildRetailOptions = (list: RetailList[]): { label: string; value: number }[] => {
  const allowedRetailerNames = new Set(ALLOCATION_TARGET_RESTRICTED_RETAILERS.map((r) => r.name));
  const availableList = allowedRetailerNames.size > 0 ? list.filter((r) => allowedRetailerNames.has(r.name)) : list;
  const options = availableList.map((r) => ({ label: r.name, value: r.id }));
  return sortRetailByPinned(options);
};
